module.exports = __webpack_public_path__ + "img/mockup4_3.aac07c19.jpg";